import {
  AccountManagerColumn,
} from '../../../../sources/charting_library.min';
import {
  StandardFormatterName,
} from '../../../../sources/charting_library';
import { ITVNotification } from './types';

type TCustomizedAccountManagerColumn =
  AccountManagerColumn & { property: keyof ITVNotification }

export const notificationTableColumns: TCustomizedAccountManagerColumn[] = [
  {
    id: 'time',
    label: 'Date and Time',
    property: 'time',
    formatter: StandardFormatterName.LocalDate,
    dataFields: ['time'],
  },
  {
    id: 'title',
    label: 'Title',
    notSortable: true,
    property: 'title',
    formatter: StandardFormatterName.Text,
    dataFields: ['title'],
  },
  {
    id: 'text',
    label: 'Text',
    property: 'text',
    notSortable: true,
    formatter: StandardFormatterName.Text,
    dataFields: ['text'],
  },
];
